import React from 'react'
import { Component } from 'react';
import authService from './AuthorizeService';
import { LogoutActions } from './ApiAuthorizationConstants';

export class Logout extends Component {
    constructor(props) {
        super(props);

        this.state = {
            message: undefined,
            isReady: false
        };
    }

    async componentDidMount() {
        const action = this.props.action;
        switch (action) {
            case LogoutActions.Logout:
                await this.logout();
                break;
            case LogoutActions.LogoutCallback:
                await this.logout();
                break;
            case LogoutActions.LoggedOut:
                this.setState({ isReady: true, message: "Du har loggat ut!" });
                setTimeout(() => window.location.replace('/'), 1000);
                break;
            default:
                throw new Error(`Invalid action '${action}'`);
        }
    }

    async logout() {
        await authService.signOut();
        this.setState({ isReady: true, message: "Du har loggat ut!" });
        setTimeout(() => window.location.replace('/'), 1000);
    }

    render() {
        const { isReady, message } = this.state;
        if (!isReady) {
            return <div>Loggar ut...</div>;
        }
        return <div>{message}</div>;
    }
}
